import BaseRequest from './index'
import { GET_PORTFOLIO } from './api'
import {} from './types'

class PortfolioService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }
  bindMethods() {
    this.portfolio = this.portfolio.bind(this)
  }
  async portfolio<T>(): Promise<T> {
    return await this.api.get(GET_PORTFOLIO)
  }
}
const portfolioService = new PortfolioService()

export default portfolioService
